import { render, staticRenderFns } from "./classManage.vue?vue&type=template&id=567576e7&scoped=true"
import script from "./classManage.vue?vue&type=script&lang=js"
export * from "./classManage.vue?vue&type=script&lang=js"
import style0 from "./classManage.vue?vue&type=style&index=0&id=567576e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567576e7",
  null
  
)

export default component.exports